export const stateLiteral = {
  borrador: 'BO',
  pendValidar: 'PV',
  reclamada: 'RE',
  pendCorrecion: 'PC',
  anulada: 'AN',
  validada: 'VA',
};
